module.exports = __webpack_public_path__ + "static/media/ThumbelinaBlack.9b7e98ad.jpeg";